module.exports = __webpack_public_path__ + "img/destinition.9deaf8fe.svg";